import React, { Component } from 'react';
import parse from 'html-react-parser';
import { SolutionTube } from '@learningblocks/storybook-components';

export class Graphics extends Component {

  toggleOpen = () => {
    this.props.solutionOpen({
      id: this.props.id,
      open: !this.props.open
    })
  }

  getSolutionTubeProps = () => {
    let  {
      solutionColor,
      circleColor,
      circleOutline,
      isOpen,
      label,
      volume,
      labelReactionTubes,
      renamable,
      solutions,
    } = this.props;

    const emptyNoLabelSolutionTube = {}

    if(!labelReactionTubes && renamable){
      return emptyNoLabelSolutionTube
    }

    if(volume <= 0 || !solutions){
      solutionColor =  null
    } 

    return { solutionColor, circleColor, circleOutline, isOpen, label: parse(label) }
  }

  render() {
    return (
      <div className="graphics"
        onClick={this.toggleOpen}
        onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.toggleOpen(e)} }>
          <SolutionTube
            isOpen={this.props.open}
            size={this.props.size}
            type={this.props.type}
            toggleOpen = {this.toggleOpen}
            solution={
              this.getSolutionTubeProps()
            }
          />
      </div>
    )
  }
}
